import Api from '@/services/Api';
import MetodosGlobais from '@/utils/MetodosGlobais';

const RECURSO = '/populacao';
export default {
    buscarPopulacaoPorIdadeSexo,
    historicoAdmissaoDesligamento,
    historicoAdmissaoPorSetor,
    admissaoDesligamentoPorSetor,
    totalAdmissaoPorRegiaoMacroMicro,
};

function buscarPopulacaoPorIdadeSexo () {
    return Api.get(`${RECURSO}/porIdadeSexo`);
}

function historicoAdmissaoDesligamento ({ultimosMeses}) {
    let params = { 'ultimosMeses': ultimosMeses };
    return Api.get(`${RECURSO}/historicoAdmissaoDesligamento${MetodosGlobais.createEncodeQuery(params)}`);
}

function historicoAdmissaoPorSetor ({ultimosMeses}) {
    let params = { 'ultimosMeses': ultimosMeses };
    return Api.get(`${RECURSO}/historicoAdmissaoPorSetor${MetodosGlobais.createEncodeQuery(params)}`);
}

function admissaoDesligamentoPorSetor () {
    return Api.get(`${RECURSO}/admissaoDesligamentoPorSetor`);
}

function totalAdmissaoPorRegiaoMacroMicro () {
    return Api.get(`${RECURSO}/totalAdmissaoPorRegiaoMacroMicro`);
}